import React from 'react';
import ReactDOM from 'react-dom';
import createHistory from 'history/createBrowserHistory'


import App from './components/App';

import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch
} from 'react-router-dom';

import withTracker from './utils/withTracker';


export default function bootstrap() {
	const history = createHistory()
	ReactDOM.render(<Router><Route component={withTracker(App)} /></Router>, document.getElementById('root'));
}



// WEBPACK FOOTER //
// ./src/js/index.js